module.exports = __webpack_public_path__ + "img/清洗上传.c9e4c490.png";